import React, { FC, ReactNode } from 'react'

export type TabPaneProps = {
  label: string
  children: ReactNode
  id?: string
}

const TabPane: FC<TabPaneProps> = ({ children, id, label }) => {
  return <div id={id ?? label}>{children}</div>
}

export default TabPane
